import { render, staticRenderFns } from "./video-m.vue?vue&type=template&id=1e6efa9c&scoped=true"
import script from "./video-m.vue?vue&type=script&lang=js"
export * from "./video-m.vue?vue&type=script&lang=js"
import style0 from "./video-m.vue?vue&type=style&index=0&id=1e6efa9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6efa9c",
  null
  
)

export default component.exports